var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 57,
    viewBox: "0 0 87 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3284 25.5539C57.4124 25.441 56.4888 25.3967 55.5656 25.4228H53.7109V30.8172H55.8107C56.8318 30.8759 57.8563 30.7757 58.8469 30.5205C59.3329 30.3407 59.7513 30.0147 60.0452 29.588C60.3385 29.1513 60.4907 28.6355 60.4802 28.1097C60.5034 27.4821 60.2859 26.8688 59.8725 26.3962C59.4674 25.9495 58.9233 25.6523 58.3284 25.5538L58.3284 25.5539Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.5024H86.5454V56.3243H0V49.5024Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3553 48.1792H5.19531C5.19531 31.3796 15.9886 17.1247 31.0571 12.0338C32.8895 11.423 34.8242 10.9137 36.8611 10.6084C38.9996 10.303 41.1375 10.0991 43.3775 10.0991C45.6175 10.0991 47.7553 10.303 49.8938 10.6084C51.8285 10.9138 53.7631 11.423 55.5955 12.0338C70.562 17.1247 81.3554 31.3792 81.3554 48.1792H81.3553Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0966 7.14603C50.0966 7.96067 49.9951 8.67301 49.6897 9.38603C47.5511 9.08063 45.4133 8.87679 43.1733 8.87679C40.9333 8.87679 38.7955 9.08063 36.657 9.38603C36.4531 8.67296 36.25 7.96061 36.25 7.14603C36.25 3.37894 39.3047 0.324219 43.0718 0.324219C47.042 0.324219 50.0967 3.37894 50.0967 7.14603H50.0966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurants);
export default __webpack_public_path__ + "static/media/restaurants.b70362550f0c5469cab5dd6e59b0eac3.svg";
export { ForwardRef as ReactComponent };